import React from 'react';
import { motion } from 'framer-motion';
import { FileText, ClipboardList, Bookmark, Stethoscope } from 'lucide-react';
export function WhatYouGetSection() {
  return <section className="w-full bg-warm-white py-16 px-6 md:py-24" data-id="element-249">
      <div className="max-w-reading mx-auto" data-id="element-250">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-251">
          <h2 className="text-3xl md:text-4xl font-bold text-charcoal mb-12 font-serif text-center" data-id="element-252">
            What you get (digital download)
          </h2>

          <div className="grid grid-cols-1 gap-8" data-id="element-253">
            {[{
            icon: FileText,
            title: 'The Quiet Bladder Reset PDF (40–60 pages)',
            desc: 'A step-by-step evening protocol, written for men 65+ in plain English.'
          }, {
            icon: ClipboardList,
            title: 'The Night Trigger Tracker (printable)',
            desc: 'A 3-minute nightly tracker that turns "I\'m up all night" into a clear pattern you can act on.'
          }, {
            icon: Bookmark,
            title: 'The Evening Protocol Card',
            desc: 'A one-page routine you can tape inside a cabinet so you don\'t have to "remember" anything at night.'
          }, {
            icon: Stethoscope,
            title: 'The Doctor One-Pager',
            desc: 'So if you need medical input, you show up with clear notes — not vague frustration.'
          }].map((item, index) => <div key={index} className="flex flex-col md:flex-row gap-6 items-start md:items-center bg-white p-6 rounded-xl border border-border-gray shadow-sm" data-id="element-254">
                <div className="bg-sage/10 p-4 rounded-full flex-shrink-0" data-id="element-255">
                  <item.icon className="w-8 h-8 text-sage-dark" data-id="element-256" />
                </div>
                <div data-id="element-257">
                  <h3 className="text-xl font-bold text-charcoal mb-2 font-serif" data-id="element-258">
                    {item.title}
                  </h3>
                  <p className="text-lg text-charcoal/80 leading-relaxed" data-id="element-259">
                    {item.desc}
                  </p>
                </div>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}